/* eslint-disable */
/** Internal type. DO NOT USE DIRECTLY. */
type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
/** Internal type. DO NOT USE DIRECTLY. */
export type Incremental<T> = T | { [P in keyof T]?: P extends ' $fragmentName' | '__typename' ? T[P] : never };
import type { DocumentTypeDecoration } from '@graphql-typed-document-node/core';
/**
 *
 * ASHPSiteStatus.
 *
 */
export type AshpSiteStatus =
  | 'ACCEPTABLE'
  | 'CHOSEN'
  | 'MISSING_NEIGHBOURS'
  | 'REJECTED'
  | 'REJECTED_FRONT_OF_HOUSE'
  | 'REJECTED_OVERHANGS'
  | 'REJECTED_OVERLAPS_WINDOW';

/** Graphene Where Input | defines filter parameter. */
export type AshpSiteWhere = {
  idIn?: Array<unknown> | null | undefined;
  model?: ModelWhere | null | undefined;
};

/** Graphene Where Input | defines filter parameter. */
export type AddressWhere = {
  active?: boolean | null | undefined;
  authorityOns?: string | null | undefined;
  bounds?: unknown;
  city?: CityWhere | null | undefined;
  combined?: string | null | undefined;
  combinedLike?: string | null | undefined;
  constituencyOns?: string | null | undefined;
  idIn?: Array<unknown> | null | undefined;
  locality?: string | null | undefined;
  number?: string | null | undefined;
  postalcode?: string | null | undefined;
  primary?: string | null | undefined;
  property?: PropertyWhere | null | undefined;
  region?: string | null | undefined;
  secondary?: string | null | undefined;
  street?: StreetWhere | null | undefined;
  territory?: string | null | undefined;
  toid?: string | null | undefined;
  uprn?: string | null | undefined;
  uprnIn?: Array<string | null | undefined> | null | undefined;
};

/** The age band of the property */
export type AgeBand =
  | 'AFTER_2012'
  | 'BEFORE_1900'
  | 'YEAR_1900_1929'
  | 'YEAR_1930_1949'
  | 'YEAR_1950_1966'
  | 'YEAR_1967_1975'
  | 'YEAR_1976_1982'
  | 'YEAR_1983_1990'
  | 'YEAR_1991_1995'
  | 'YEAR_1996_2002'
  | 'YEAR_2003_2006'
  | 'YEAR_2007_2011';

/** Categorisation for annotation -- powers accepted relationships and expected value formats. */
export type AnnotationCategory =
  | 'CHIMNEY'
  | 'DOOR'
  | 'GROUND'
  | 'ROOF'
  | 'THERMAL_AUTO'
  | 'UNKNOWN'
  | 'WALL'
  | 'WINDOW';

/** Types annotation can take -- powers accepted relationships and expected value formats. */
export type AnnotationType =
  | 'AREA'
  | 'DIMENSION'
  | 'FEATURE'
  | 'POINT'
  | 'THERMAL'
  | 'UNKNOWN';

/** An enumeration. */
export type ApvFilterField =
  | 'ADDRESS_COMBINED'
  | 'ARCHETYPE'
  | 'BUILD_YEAR'
  | 'CITY'
  | 'EPC_BAND_DELTA'
  | 'EPC_CHECKER'
  | 'EPC_LODGED_AGE'
  | 'EPC_LODGED_GRADE'
  | 'EPC_LODGED_SAP_SCORE'
  | 'EPC_PREDICTED_AGE'
  | 'EPC_PREDICTED_GRADE'
  | 'EPC_PREDICTED_SAP_SCORE'
  | 'HEAT_PUMP_AIR_VOLUME'
  | 'HEAT_PUMP_ID'
  | 'HEAT_PUMP_LOCATION_SUITABILITY'
  | 'HEAT_PUMP_NOISE_COMPLIANCE'
  | 'HEAT_PUMP_PUBLIC_VISIBILITY'
  | 'MODEL_ID'
  | 'MODEL_SCORE'
  | 'NUMBER_OF_RETROFIT_ACTIONS'
  | 'NUMBER_OF_UNIQUE_RETROFIT_ACTIONS'
  | 'ORGANISATION_ID'
  | 'POSTALCODE'
  | 'PROPERTYLIST_IDS'
  | 'PROPERTY_ID'
  | 'PROPERTY_TYPE'
  | 'RETROFIT_ACTION_NAMES'
  | 'RETROFIT_ACTION_TYPES'
  | 'RETROFIT_COMPONENT_TYPES'
  | 'STREET'
  | 'UPRN';

/** One `{field, direction}` sort key for `prioritisationQuery`. */
export type ApvSortInput = {
  direction?: SortDirection | null | undefined;
  field: PrioritisationSortField;
};

/** An enumeration. */
export type ArvValueField =
  | 'CONFIDENCE_LEVEL'
  | 'NAME'
  | 'SUBJECT_TYPE';

/** Graphene Where Input | defines filter parameter. */
export type CityWhere = {
  addresses?: AddressWhere | null | undefined;
  bounds?: unknown;
  idFromSource?: string | null | undefined;
  idIn?: Array<unknown> | null | undefined;
  name?: string | null | undefined;
  source?: DataSource | null | undefined;
  tagsHasAll?: Array<string | null | undefined> | null | undefined;
  tagsHasAny?: Array<string | null | undefined> | null | undefined;
  tagsNotHasAll?: Array<string | null | undefined> | null | undefined;
  tagsNotHasAny?: Array<string | null | undefined> | null | undefined;
};

/** Graphene Input schema | SuperAdmin Create User. */
export type CreateUserInput = {
  email: string;
  organisationId: unknown;
  password: string;
  role: string;
  username: string;
};

/** Describes the origin of some data points. */
export type DataSource =
  | 'GOOGLE_STREETVIEW_MANUAL'
  | 'KESTRIX'
  | 'KESTRIX_SAP_COMPARATOR'
  | 'ORDNANCE_SURVEY'
  | 'PROPECO';

/** The EPC rating of the property */
export type EpcRating =
  | 'A'
  | 'B'
  | 'C'
  | 'D'
  | 'E'
  | 'F'
  | 'G';

/** Graphene Where Input | defines filter parameter. */
export type ModelAssociationModelWhere = {
  active?: boolean | null | undefined;
  idIn?: Array<unknown> | null | undefined;
  statusHasAll?: Array<string | null | undefined> | null | undefined;
  statusHasAny?: Array<string | null | undefined> | null | undefined;
  statusNotHasAll?: Array<string | null | undefined> | null | undefined;
  statusNotHasAny?: Array<string | null | undefined> | null | undefined;
  tagsHasAll?: Array<string | null | undefined> | null | undefined;
  tagsHasAny?: Array<string | null | undefined> | null | undefined;
  tagsNotHasAll?: Array<string | null | undefined> | null | undefined;
  tagsNotHasAny?: Array<string | null | undefined> | null | undefined;
};

/** Graphene Where Input | defines filter parameter. */
export type ModelAssociationWhere = {
  idIn?: Array<unknown> | null | undefined;
  model?: ModelAssociationModelWhere | null | undefined;
  property?: PropertyWhere | null | undefined;
  propertyComposite?: PropertyCompositeWhere | null | undefined;
  propertyMasks?: PropertyWhere | null | undefined;
  propertyUnit?: PropertyUnitWhere | null | undefined;
};

/** Graphene Where Input | defines filter parameter. */
export type ModelWhere = {
  active?: boolean | null | undefined;
  associations?: ModelAssociationWhere | null | undefined;
  idIn?: Array<unknown> | null | undefined;
  isLatestForProperty?: boolean | null | undefined;
  lock?: unknown;
  statusHasAll?: Array<string | null | undefined> | null | undefined;
  statusHasAny?: Array<string | null | undefined> | null | undefined;
  statusNotHasAll?: Array<string | null | undefined> | null | undefined;
  statusNotHasAny?: Array<string | null | undefined> | null | undefined;
  tagsHasAll?: Array<string | null | undefined> | null | undefined;
  tagsHasAny?: Array<string | null | undefined> | null | undefined;
  tagsNotHasAll?: Array<string | null | undefined> | null | undefined;
  tagsNotHasAny?: Array<string | null | undefined> | null | undefined;
};

/** Graphene Input Schema | Organisation Create. */
export type OrganisationCreateInput = {
  name?: string | null | undefined;
};

/** Graphene Where Input | defines filter parameter. */
export type OrganisationWhere = {
  idIn?: Array<unknown> | null | undefined;
};

/** Graphene Where Input | defines filter parameter. */
export type OrganisationWhereUnique = {
  id?: unknown;
  name?: string | null | undefined;
};

/** Graphene Type | Extended RoyDefaultAbleWhere to support limited returns and paging for target DB model. */
export type Paging = {
  limit?: number | null | undefined;
  page?: number | null | undefined;
};

/** An enumeration. */
export type PrioritisationFilterField =
  | 'ADDRESS_COMBINED'
  | 'ARCHETYPE'
  | 'ASHP_AIRFLOW'
  | 'ASHP_NEIGHBOUR_NOISE'
  | 'ASHP_SITE_SUITABILITY'
  | 'BUILD_YEAR'
  | 'CITY'
  | 'CONFIDENCE_LEVEL'
  | 'CONFIDENCE_SCORE'
  | 'CONFIDENCE_WARNINGS'
  | 'EPC_BAND_DELTA'
  | 'EPC_CHECKER'
  | 'EPC_LODGED_AGE'
  | 'EPC_LODGED_GRADE'
  | 'EPC_LODGED_SAP_SCORE'
  | 'EPC_PREDICTED_AGE'
  | 'EPC_PREDICTED_GRADE'
  | 'EPC_PREDICTED_SAP_SCORE'
  | 'HAS_SAP_COMPARISON'
  | 'HEAT_PUMP_AIR_VOLUME'
  | 'HEAT_PUMP_ID'
  | 'HEAT_PUMP_LOCATION_SUITABILITY'
  | 'HEAT_PUMP_NOISE_COMPLIANCE'
  | 'HEAT_PUMP_PUBLIC_VISIBILITY'
  | 'IS_ASHP_RECOMMENDATION'
  | 'IS_SOLAR_RECOMMENDATION'
  | 'MODEL_ID'
  | 'MODEL_SCORE'
  | 'NAME'
  | 'NUMBER_OF_RETROFIT_ACTIONS'
  | 'NUMBER_OF_UNIQUE_RETROFIT_ACTIONS'
  | 'ORGANISATION_ID'
  | 'POSTALCODE'
  | 'PROPERTYLIST_IDS'
  | 'PROPERTY_ID'
  | 'PROPERTY_TYPE'
  | 'RETROFIT_ACTION_NAMES'
  | 'RETROFIT_ACTION_TYPES'
  | 'RETROFIT_COMPONENT_TYPES'
  | 'SAP_UPLIFT'
  | 'SOLAR_ANNUAL_OUTPUT_KWH'
  | 'SOLAR_KWP'
  | 'SOLAR_NUM_PANELS'
  | 'STREET'
  | 'SUBJECT_TYPE'
  | 'UPRN';

/** An enumeration. */
export type PrioritisationFilterOperator =
  | 'CONTAINS'
  | 'CONTAINS_ANY_OF'
  | 'IS'
  | 'IS_ANY_OF'
  | 'IS_AT_LEAST'
  | 'IS_AT_MOST'
  | 'IS_BETWEEN'
  | 'IS_EMPTY'
  | 'IS_NOT_EMPTY';

/** One `{field, operator, value}` filter rule for `prioritisationQuery` -- an APV or ARV field. */
export type PrioritisationFilterRule = {
  field: PrioritisationFilterField;
  operator: PrioritisationFilterOperator;
  value: unknown;
};

/** An enumeration. */
export type PrioritisationSortField =
  | 'ADDRESS_COMBINED'
  | 'ARCHETYPE'
  | 'ASHP_AIRFLOW'
  | 'ASHP_CONFIDENCE_LEVEL'
  | 'ASHP_CONFIDENCE_SCORE'
  | 'ASHP_HAS_SAP_COMPARISON'
  | 'ASHP_NEIGHBOUR_NOISE'
  | 'ASHP_SAP_UPLIFT'
  | 'ASHP_SITE_SUITABILITY'
  | 'BUILD_YEAR'
  | 'CITY'
  | 'EPC_BAND_DELTA'
  | 'EPC_CHECKER'
  | 'EPC_LODGED_AGE'
  | 'EPC_LODGED_GRADE'
  | 'EPC_LODGED_SAP_SCORE'
  | 'EPC_PREDICTED_AGE'
  | 'EPC_PREDICTED_GRADE'
  | 'EPC_PREDICTED_SAP_SCORE'
  | 'HEAT_PUMP_AIR_VOLUME'
  | 'HEAT_PUMP_LOCATION_SUITABILITY'
  | 'HEAT_PUMP_NOISE_COMPLIANCE'
  | 'HEAT_PUMP_PUBLIC_VISIBILITY'
  | 'MODEL_SCORE'
  | 'NUMBER_OF_RETROFIT_ACTIONS'
  | 'NUMBER_OF_UNIQUE_RETROFIT_ACTIONS'
  | 'POSTALCODE'
  | 'PROPERTY_TYPE'
  | 'SOLAR_ANNUAL_OUTPUT_KWH'
  | 'SOLAR_CONFIDENCE_LEVEL'
  | 'SOLAR_CONFIDENCE_SCORE'
  | 'SOLAR_HAS_SAP_COMPARISON'
  | 'SOLAR_KWP'
  | 'SOLAR_NUM_PANELS'
  | 'SOLAR_SAP_UPLIFT'
  | 'STREET'
  | 'UPRN';

/** Graphene Where Input | defines filter parameter. */
export type PropertyCompositeWhere = {
  idIn?: Array<unknown> | null | undefined;
};

/** Graphene Where Input | defines filter parameter. */
export type PropertyEnergyPerformanceInspectionWhere = {
  idIn?: Array<unknown> | null | undefined;
  property?: PropertyWhere | null | undefined;
  sourceIn?: Array<DataSource | null | undefined> | null | undefined;
};

/** Property form mapping from OS data used by EPC. */
export type PropertyForm =
  | 'DETACHED'
  | 'ENDTERRACE'
  | 'FLAT'
  | 'SEMIDETACHED'
  | 'TERRACED'
  | 'UNKNOWN';

/**
 * Graphene Input Schema | One list's status and priority in a bulk update
 *
 * Each item sets both fields. A null priority takes the list out of the order.
 */
export type PropertyListBulkUpdateInput = {
  id: unknown;
  priority?: number | null | undefined;
  status: PropertyListStatus;
};

/** Status Enum | Property Lists. */
export type PropertyListStatus =
  | 'DELIVERED'
  | 'DRAFT'
  | 'IN_DELIVERY';

/** Graphene Where Input | defines filter parameter. */
export type PropertyListWhere = {
  idIn?: Array<unknown> | null | undefined;
  organisation?: OrganisationWhere | null | undefined;
  statusIn?: Array<string | null | undefined> | null | undefined;
};

/** Graphene Where Input | defines filter parameter. */
export type PropertyModelAssociationWhere = {
  model?: PropertyModelWhere | null | undefined;
};

/** Graphene Where Input | filter parameters for a model */
export type PropertyModelWhere = {
  active?: boolean | null | undefined;
  statusHasAll?: Array<string | null | undefined> | null | undefined;
  statusHasAny?: Array<string | null | undefined> | null | undefined;
  statusNotHasAll?: Array<string | null | undefined> | null | undefined;
  statusNotHasAny?: Array<string | null | undefined> | null | undefined;
  tagsHasAll?: Array<string | null | undefined> | null | undefined;
  tagsHasAny?: Array<string | null | undefined> | null | undefined;
  tagsNotHasAll?: Array<string | null | undefined> | null | undefined;
  tagsNotHasAny?: Array<string | null | undefined> | null | undefined;
};

/** The order condition of the properties */
export type PropertyOrderCondition =
  | 'AGE_BAND'
  | 'EPC_COMPARISON_ABS'
  | 'EPC_COMPARISON_REL'
  | 'EPC_EXPIRY_DATE'
  | 'EPC_LODGEMENT_DATE'
  | 'EPC_RATING'
  | 'EPC_SPACE_HEATING_DEMAND'
  | 'KESTRIX_SPACE_HEATING_DEMAND'
  | 'POSTCODE'
  | 'STREET_NAME'
  | 'TOWN_NAME';

/** Property types mapping from OS data. */
export type PropertyType =
  | 'BUNGALOW'
  | 'FLAT'
  | 'HOUSE'
  | 'MAISONETTE'
  | 'PARK_HOME'
  | 'UNKNOWN';

/** Graphene Where Input | defines filter parameter. */
export type PropertyUnitWhere = {
  active?: boolean | null | undefined;
  extensionOf?: PropertyUnitWhere | null | undefined;
  idIn?: Array<unknown> | null | undefined;
  property?: PropertyWhere | null | undefined;
};

/** Graphene Input Schema | Property View create. */
export type PropertyViewCreateInput = {
  columns: unknown;
  description?: string | null | undefined;
  name: string;
  rules: unknown;
  sort?: Array<PropertyViewSortInput> | null | undefined;
};

/** An enumeration. */
export type PropertyViewSortField =
  | 'ADDRESS_COMBINED'
  | 'ARCHETYPE'
  | 'ASHP_AIRFLOW'
  | 'ASHP_CONFIDENCE_LEVEL'
  | 'ASHP_CONFIDENCE_SCORE'
  | 'ASHP_HAS_SAP_COMPARISON'
  | 'ASHP_NEIGHBOUR_NOISE'
  | 'ASHP_SAP_UPLIFT'
  | 'ASHP_SITE_SUITABILITY'
  | 'BUILD_YEAR'
  | 'CITY'
  | 'EPC_BAND_DELTA'
  | 'EPC_CHECKER'
  | 'EPC_LODGED_AGE'
  | 'EPC_LODGED_GRADE'
  | 'EPC_LODGED_SAP_SCORE'
  | 'EPC_PREDICTED_AGE'
  | 'EPC_PREDICTED_GRADE'
  | 'EPC_PREDICTED_SAP_SCORE'
  | 'HEAT_PUMP_AIR_VOLUME'
  | 'HEAT_PUMP_LOCATION_SUITABILITY'
  | 'HEAT_PUMP_NOISE_COMPLIANCE'
  | 'HEAT_PUMP_PUBLIC_VISIBILITY'
  | 'MODEL_SCORE'
  | 'NUMBER_OF_RETROFIT_ACTIONS'
  | 'NUMBER_OF_UNIQUE_RETROFIT_ACTIONS'
  | 'POSTALCODE'
  | 'PROPERTY_TYPE'
  | 'SOLAR_ANNUAL_OUTPUT_KWH'
  | 'SOLAR_CONFIDENCE_LEVEL'
  | 'SOLAR_CONFIDENCE_SCORE'
  | 'SOLAR_HAS_SAP_COMPARISON'
  | 'SOLAR_KWP'
  | 'SOLAR_NUM_PANELS'
  | 'SOLAR_SAP_UPLIFT'
  | 'STREET'
  | 'UPRN';

/** Graphene Input Schema | Property View sort -- one `{field, direction}` pair. */
export type PropertyViewSortInput = {
  direction: SortDirection;
  field: PropertyViewSortField;
};

/** Graphene Input Schema | Property View update. */
export type PropertyViewUpdateInput = {
  columns?: unknown;
  description?: string | null | undefined;
  name?: string | null | undefined;
  rules?: unknown;
  sort?: Array<PropertyViewSortInput> | null | undefined;
};

/** Graphene Where Input | property view list filter. */
export type PropertyViewWhere = {
  idIn?: Array<unknown> | null | undefined;
  organisation?: OrganisationWhere | null | undefined;
};

/** Graphene Where Input | unique property view filter. */
export type PropertyViewWhereUnique = {
  id?: unknown;
};

/** Graphene Where Input | defines filter parameter. */
export type PropertyWhere = {
  address?: AddressWhere | null | undefined;
  ageIn?: Array<AgeBand | null | undefined> | null | undefined;
  /**
   * List of integer values from -6 to 6 describing the number of points difference between
   *         Kestrix and EPC ratings. Positive values show Kestrix rating is more energy efficient than EPC
   */
  engPerfInspectionComparisonIn?: Array<number | null | undefined> | null | undefined;
  engPerfInspectionLatestExpiryAfter?: unknown;
  engPerfInspectionLatestExpiryBefore?: unknown;
  engPerfInspectionLatestLodgedAfter?: unknown;
  engPerfInspectionLatestLodgedBefore?: unknown;
  engPerfInspections?: PropertyEnergyPerformanceInspectionWhere | null | undefined;
  epcRatingIn?: Array<EpcRating | null | undefined> | null | undefined;
  formIn?: Array<PropertyForm | null | undefined> | null | undefined;
  idIn?: Array<unknown> | null | undefined;
  isModelAvailable?: boolean | null | undefined;
  lists?: PropertyListWhere | null | undefined;
  models?: PropertyModelAssociationWhere | null | undefined;
  propertyComposite?: PropertyCompositeWhere | null | undefined;
  sortBy?: PropertyOrderCondition | null | undefined;
  sortDirection?: Sort_Order | null | undefined;
  statusHasAll?: Array<string | null | undefined> | null | undefined;
  statusHasAny?: Array<string | null | undefined> | null | undefined;
  statusNotHasAll?: Array<string | null | undefined> | null | undefined;
  statusNotHasAny?: Array<string | null | undefined> | null | undefined;
  typeIn?: Array<PropertyType | null | undefined> | null | undefined;
};

/** Graphene Where Input | defines filter parameter. */
export type PropertyWhereUnique = {
  id?: unknown;
};

/**
 * Sort direction for a materialised-view prioritisation query's `orderBy`.
 *
 * Shared between APV and ARV -- previously each declared its own copy
 * (`ApvSortDirection`, ARV's `SortDirection`) because ARV's field registry
 * was unmerged when APV's was built. Both have landed now, so there is one
 * enum.
 */
export type SortDirection =
  | 'ASC'
  | 'DESC';

/** The sort order of returned rows */
export type Sort_Order =
  | 'ASC'
  | 'DESC';

/** Graphene Where Input | defines filter parameter. */
export type StreetWhere = {
  addresses?: AddressWhere | null | undefined;
  bounds?: unknown;
  city?: CityWhere | null | undefined;
  cityId?: unknown;
  idFromSource?: string | null | undefined;
  idIn?: Array<unknown> | null | undefined;
  name?: string | null | undefined;
  source?: DataSource | null | undefined;
  tagsHasAll?: Array<string | null | undefined> | null | undefined;
  tagsHasAny?: Array<string | null | undefined> | null | undefined;
  tagsNotHasAll?: Array<string | null | undefined> | null | undefined;
  tagsNotHasAny?: Array<string | null | undefined> | null | undefined;
};

/** Graphene Input Schema | User Admin Full. */
export type UserConfigInput = {
  email?: string | null | undefined;
  organisation?: UserConnectOrganisationWhereUnique | null | undefined;
  password?: string | null | undefined;
  role?: string | null | undefined;
};

export type UserConnectOrganisationWhereUnique = {
  connect?: OrganisationWhereUnique | null | undefined;
  disconnect?: OrganisationWhereUnique | null | undefined;
};

export type AdminCreateOrganisationMutationVariables = Exact<{
  data: OrganisationCreateInput;
}>;


export type AdminCreateOrganisationMutation = { organisationCreate: { organisation: { id: string, name: string | null } | null } | null };

export type AdminRenameOrganisationMutationVariables = Exact<{
  id?: unknown;
  name?: string | null | undefined;
}>;


export type AdminRenameOrganisationMutation = { organisationUpdate: { organisation: { id: string, name: string | null } | null } | null };

export type AdminCreateUserMutationVariables = Exact<{
  data: CreateUserInput;
}>;


export type AdminCreateUserMutation = { createUser: { user: { id: string } | null } | null };

export type AdminCreatePropertyListMutationVariables = Exact<{
  name: string;
  organisationId?: unknown;
}>;


export type AdminCreatePropertyListMutation = { propertyListCreate: { propertyList: { id: string } | null } | null };

export type AdminSetPropertyListStatusMutationVariables = Exact<{
  id?: unknown;
  status?: PropertyListStatus | null | undefined;
}>;


export type AdminSetPropertyListStatusMutation = { propertyListUpdate: { propertyList: { id: string } | null } | null };

export type DroneOpsSaveOrderMutationVariables = Exact<{
  data: Array<PropertyListBulkUpdateInput> | PropertyListBulkUpdateInput;
}>;


export type DroneOpsSaveOrderMutation = { propertyListBulkUpdate: { propertyLists: Array<{ id: string } | null> | null } | null };

export type AdminUpdateUserMutationVariables = Exact<{
  id?: unknown;
  data: UserConfigInput;
}>;


export type AdminUpdateUserMutation = { userConfig: { user: { id: string } | null } | null };

export type AdminOrganisationsQueryVariables = Exact<{
  paging?: Paging | null | undefined;
  countPaging?: Paging | null | undefined;
}>;


export type AdminOrganisationsQuery = { organisations: Array<{ id: string, name: string | null, users: Array<{ id: string } | null> | null, lists: Array<{ id: string } | null> | null } | null> | null };

export type AdminOrganisationQueryVariables = Exact<{
  id?: unknown;
  countPaging?: Paging | null | undefined;
}>;


export type AdminOrganisationQuery = { organisation: { id: string, name: string | null, users: Array<{ id: string, username: string | null, email: string | null, role: string } | null> | null, lists: Array<{ id: string } | null> | null } | null };

export type AdminUserRolesQueryVariables = Exact<{ [key: string]: never; }>;


export type AdminUserRolesQuery = { userRoles: { userRoles: Array<string | null> | null } | null };

export type AdminPropertyListsQueryVariables = Exact<{
  organisationId?: unknown;
}>;


export type AdminPropertyListsQuery = { propertyLists: Array<{ id: string, name: string | null, status: string | null, priority: number | null } | null> | null };

export type AdminPropertyListCountQueryVariables = Exact<{
  listId?: unknown;
}>;


export type AdminPropertyListCountQuery = { propertyAggregate: { totalCount: number | null } | null };

export type DroneOpsPropertyListsQueryVariables = Exact<{ [key: string]: never; }>;


export type DroneOpsPropertyListsQuery = { propertyLists: Array<{ id: string, name: string | null, status: string | null, priority: number | null, organisation: { id: string, name: string | null } | null } | null> | null };

export type ApvFilterOptionsQueryVariables = Exact<{
  organisationId?: string | null | undefined;
}>;


export type ApvFilterOptionsQuery = { apvFilterOptions: { archetypes: Array<string | null> | null, retrofitActionTypes: Array<string | null> | null } | null };

export type OrganisationsQueryVariables = Exact<{
  paging?: Paging | null | undefined;
}>;


export type OrganisationsQuery = { organisations: Array<{ id: string, name: string | null } | null> | null };

export type ApvDataPropertyIdsQueryQueryVariables = Exact<{
  organisationId?: string | null | undefined;
  filterRules?: Array<PrioritisationFilterRule> | PrioritisationFilterRule | null | undefined;
  propertyIdIn?: Array<string | number> | string | number | null | undefined;
  page?: number | null | undefined;
  pageSize?: number | null | undefined;
}>;


export type ApvDataPropertyIdsQueryQuery = { prioritisationQuery: { totalCount: number, rows: Array<{ propertyId: string, modelId: string }> } | null };

export type ArvFieldValuesQueryVariables = Exact<{
  field: ArvValueField;
  organisationId?: string | null | undefined;
  filterRules?: Array<PrioritisationFilterRule> | PrioritisationFilterRule | null | undefined;
  propertyIdIn?: Array<string | number> | string | number | null | undefined;
  limit?: number | null | undefined;
}>;


export type ArvFieldValuesQuery = { arvFieldValues: Array<{ value: string | null, label: string | null, groupValue: string | null }> };

export type ApvFieldValuesQueryVariables = Exact<{
  field: ApvFilterField;
  organisationId?: string | null | undefined;
  search?: string | null | undefined;
  limit?: number | null | undefined;
}>;


export type ApvFieldValuesQuery = { apvFieldValues: Array<{ value: string | null, label: string | null }> };

export type PlanPropertyListsQueryVariables = Exact<{
  where?: PropertyListWhere | null | undefined;
}>;


export type PlanPropertyListsQuery = { propertyLists: Array<{ id: string, name: string | null } | null> | null };

export type SolarEligibleCountQueryVariables = Exact<{
  organisationId?: string | null | undefined;
  filterRules?: Array<PrioritisationFilterRule> | PrioritisationFilterRule | null | undefined;
}>;


export type SolarEligibleCountQuery = { prioritisationQuery: { totalCount: number } | null };

export type ModelViewerAshpSitesQueryVariables = Exact<{
  where?: AshpSiteWhere | null | undefined;
}>;


export type ModelViewerAshpSitesQuery = { ashpSites: Array<{ id: string, status: AshpSiteStatus | null, airVolume: number | null, bearing: number | null, noiseImpact: number | null, warnings: string | null, ashpUnit: { id: string, manufacturer: string | null, unitName: string | null, heatingCapacity: number | null, scop: number | null, maxNoise: number | null, width: number | null, height: number | null, depth: number | null } | null } | null> | null };

export type ModelViewerPropertyQueryVariables = Exact<{
  organisationId?: string | null | undefined;
  propertyIdIn?: Array<string | number> | string | number | null | undefined;
  filterRules?: Array<PrioritisationFilterRule> | PrioritisationFilterRule | null | undefined;
}>;


export type ModelViewerPropertyQuery = { prioritisationQuery: { rows: Array<{ propertyId: string, modelId: string, addressCombined: string | null, propertyType: string | null, buildYear: number | null, epcLodgedGrade: string | null, epcPredictedGrade: string | null, epcLodgedSapScore: number | null, epcPredictedSapScore: number | null, epcLodgedAge: number | null, sapComparatorMode: string | null, comparatorSapPredicted: number | null, comparatorSpaceHeatingIntensity: number | null, comparatorFloorAreaM2: number | null, lodgedFloorAreaM2: number | null, wallUValue: number | null, capturedOn: unknown, recommendations: Array<{ recommendationId: string | null, name: string | null, displayName: string | null, subjectType: string | null, sapUplift: number | null, isAshpRecommendation: boolean | null, isSolarRecommendation: boolean | null, solarNumPanels: number | null, solarKwp: number | null, solarAnnualOutputKwh: number | null }> }> } | null };

export type PlanMapSolarValuesQueryQueryVariables = Exact<{
  organisationId?: string | null | undefined;
  filterRules?: Array<PrioritisationFilterRule> | PrioritisationFilterRule | null | undefined;
  propertyIdIn?: Array<string | number> | string | number | null | undefined;
  page?: number | null | undefined;
  pageSize?: number | null | undefined;
}>;


export type PlanMapSolarValuesQueryQuery = { prioritisationQuery: { totalCount: number, rows: Array<{ propertyId: string, modelId: string, recommendations: Array<{ isSolarRecommendation: boolean | null, solarAnnualOutputKwh: number | null, sapUplift: number | null }> }> } | null };

export type PlanMapStreetsQueryVariables = Exact<{
  where?: StreetWhere | null | undefined;
  paging?: Paging | null | undefined;
}>;


export type PlanMapStreetsQuery = { streets: Array<{ id: string, name: string, geometry: unknown } | null> | null };

export type PlanMapQueryQueryVariables = Exact<{
  organisationId?: string | null | undefined;
  filterRules?: Array<PrioritisationFilterRule> | PrioritisationFilterRule | null | undefined;
  propertyIdIn?: Array<string | number> | string | number | null | undefined;
  page?: number | null | undefined;
  pageSize?: number | null | undefined;
}>;


export type PlanMapQueryQuery = { prioritisationQuery: { totalCount: number, rows: Array<{ propertyId: string, modelId: string, latitude: number | null, longitude: number | null, addressCombined: string | null, epcLodgedGrade: string | null, epcPredictedGrade: string | null, boundary: unknown, streetId: string | null }> } | null };

export type PlanPropertyDetailQueryVariables = Exact<{
  organisationId?: string | null | undefined;
  propertyIdIn?: Array<string | number> | string | number | null | undefined;
  filterRules?: Array<PrioritisationFilterRule> | PrioritisationFilterRule | null | undefined;
}>;


export type PlanPropertyDetailQuery = { prioritisationQuery: { rows: Array<{ propertyId: string, modelId: string, addressCombined: string | null, city: string | null, propertyType: string | null, archetype: string | null, buildingAge: string | null, epcLodgedGrade: string | null, epcPredictedGrade: string | null, recommendations: Array<{ recommendationId: string | null, name: string | null, displayName: string | null, subjectType: string | null, isSolarRecommendation: boolean | null, solarNumPanels: number | null, solarKwp: number | null, solarAnnualOutputKwh: number | null, sapUplift: number | null, confidenceLevel: string | null, confidenceScore: number | null, confidenceWarnings: Array<string | null> | null }> }> } | null };

export type PlanStreetDetailQueryVariables = Exact<{
  organisationId?: string | null | undefined;
  propertyIdIn?: Array<string | number> | string | number | null | undefined;
  pageSize?: number | null | undefined;
}>;


export type PlanStreetDetailQuery = { prioritisationQuery: { rows: Array<{ propertyId: string, modelId: string, city: string | null, propertyType: string | null, recommendations: Array<{ isSolarRecommendation: boolean | null, solarNumPanels: number | null, solarKwp: number | null, solarAnnualOutputKwh: number | null }> }> } | null };

export type PlanQueryQueryVariables = Exact<{
  organisationId?: string | null | undefined;
  filterRules?: Array<PrioritisationFilterRule> | PrioritisationFilterRule | null | undefined;
  sort?: Array<ApvSortInput> | ApvSortInput | null | undefined;
  propertyIdIn?: Array<string | number> | string | number | null | undefined;
  page?: number | null | undefined;
  pageSize?: number | null | undefined;
}>;


export type PlanQueryQuery = { prioritisationQuery: { totalCount: number, rows: Array<{ modelId: string, propertyId: string, organisationId: string, numberOfRetrofitActions: number, numberOfUniqueRetrofitActions: number, retrofitActionsByType: unknown, numberOfRetrofitActionsByComponent: unknown, wallTotalActions: unknown, roofTotalActions: unknown, windowTotalActions: unknown, doorTotalActions: unknown, chimneyTotalActions: unknown, groundTotalActions: unknown, shdDeltaByAction: unknown, epcLodgedGrade: string | null, epcPredictedGrade: string | null, epcLodgedSapScore: number | null, epcPredictedSapScore: number | null, epcBandDelta: number | null, epcChecker: string | null, epcLodgedAge: number | null, epcPredictedAge: number | null, buildYear: number | null, modelScore: number | null, archetype: string | null, postalcode: string | null, street: string | null, city: string | null, uprn: string | null, addressCombined: string | null, propertyType: string | null, heatPumpId: string | null, heatPumpStatus: string | null, heatPumpLocationSuitability: number | null, heatPumpNoiseCompliance: number | null, heatPumpPublicVisibility: number | null, heatPumpAirVolume: number | null, propertylistIds: Array<string>, recommendations: Array<{ recommendationId: string | null, propertyId: string | null, modelId: string | null, displayName: string | null, subjectType: string | null, isSolarRecommendation: boolean | null, solarNumPanels: number | null, solarKwp: number | null, solarAnnualOutputKwh: number | null, sapUplift: number | null, confidenceScore: number | null, confidenceLevel: string | null, confidenceWarnings: Array<string | null> | null }> }> } | null };

export type PropertyViewCreateMutationVariables = Exact<{
  data: PropertyViewCreateInput;
  organisationId?: string | null | undefined;
}>;


export type PropertyViewCreateMutation = { propertyViewCreate: { propertyView: { id: string, name: string, description: string | null, fieldNamespaceGeneration: number, rules: unknown, columns: unknown, sort: Array<{ field: PropertyViewSortField | null, direction: SortDirection | null }> | null } | null } | null };

export type PropertyViewUpdateMutationVariables = Exact<{
  data: PropertyViewUpdateInput;
  where: PropertyViewWhereUnique;
}>;


export type PropertyViewUpdateMutation = { propertyViewUpdate: { propertyView: { id: string, name: string, description: string | null, fieldNamespaceGeneration: number, rules: unknown, columns: unknown, sort: Array<{ field: PropertyViewSortField | null, direction: SortDirection | null }> | null } | null } | null };

export type PropertyViewDeleteMutationVariables = Exact<{
  where: PropertyViewWhere;
}>;


export type PropertyViewDeleteMutation = { propertyViewDelete: { success: boolean | null, rowsAffected: number | null } | null };

export type PropertyViewsQueryVariables = Exact<{
  where?: PropertyViewWhere | null | undefined;
}>;


export type PropertyViewsQuery = { propertyViews: Array<{ id: string, name: string, description: string | null, fieldNamespaceGeneration: number, rules: unknown, columns: unknown, sort: Array<{ field: PropertyViewSortField | null, direction: SortDirection | null }> | null } | null> | null };

export type PropertyListsQueryVariables = Exact<{
  where?: PropertyListWhere | null | undefined;
}>;


export type PropertyListsQuery = { propertyLists: Array<{ id: string, name: string | null } | null> | null };

export type PropertyTablePageQueryVariables = Exact<{
  where: PropertyWhere;
  paging: Paging;
}>;


export type PropertyTablePageQuery = { properties: Array<{ id: string, type: PropertyType | null, address: Array<{ combined: string | null } | null> | null, units: Array<{ form: PropertyForm | null, age: string | null } | null> | null, kestrixInspections: Array<{ inspectionDate: unknown, source: DataSource, spaceHeatingDemand: number, currentRating: string } | null> | null, epcInspections: Array<{ inspectionDate: unknown, source: DataSource, spaceHeatingDemand: number, currentRating: string } | null> | null, predictedInspections: Array<{ inspectionDate: unknown, source: DataSource, currentRating: string } | null> | null, models: Array<{ modelId: string | null, model: { id: string, active: boolean | null } | null } | null> | null } | null> | null };

export type PropertyMapMarkersPageQueryVariables = Exact<{
  where: PropertyWhere;
  paging: Paging;
}>;


export type PropertyMapMarkersPageQuery = { properties: Array<{ id: string, address: Array<{ combined: string | null, latlng: unknown } | null> | null, epcInspections: Array<{ currentRating: string, inspectionDate: unknown } | null> | null, predictedInspections: Array<{ currentRating: string, inspectionDate: unknown } | null> | null, models: Array<{ modelId: string | null } | null> | null } | null> | null };

export type PropertyOverlayQueryVariables = Exact<{
  where: PropertyWhereUnique;
}>;


export type PropertyOverlayQuery = { property: { id: string, type: PropertyType | null, address: Array<{ combined: string | null, latlng: unknown, uprn: string | null } | null> | null, units: Array<{ form: PropertyForm | null, age: string | null } | null> | null, kestrixInspections: Array<{ inspectionDate: unknown, source: DataSource, spaceHeatingDemand: number, currentRating: string } | null> | null, epcInspections: Array<{ inspectionDate: unknown, source: DataSource, spaceHeatingDemand: number, currentRating: string } | null> | null, predictedInspections: Array<{ inspectionDate: unknown, source: DataSource, currentRating: string } | null> | null, models: Array<{ modelId: string | null, model: { id: string, active: boolean | null, recommendations: Array<{ parentRecommendationId: string | null, shdDeltaAfterUpgrade: string | null, retrofitAction: { displayName: string | null, subjectType: AnnotationCategory | null } | null } | null> | null } | null } | null> | null } | null };

export type PropertyDetailQueryVariables = Exact<{
  where: PropertyWhereUnique;
}>;


export type PropertyDetailQuery = { property: { id: string, type: PropertyType | null, address: Array<{ uprn: string | null, combined: string | null, latlng: unknown } | null> | null, units: Array<{ form: PropertyForm | null, age: string | null } | null> | null, kestrixInspections: Array<{ inspectionDate: unknown, source: DataSource, spaceHeatingDemand: number, currentRating: string } | null> | null, epcInspections: Array<{ inspectionDate: unknown, source: DataSource, spaceHeatingDemand: number, currentRating: string } | null> | null, models: Array<{ model: { id: string, active: boolean | null, files: { glb: string | null } | null, annotations: Array<{ active: boolean | null, type: AnnotationType | null, category: AnnotationCategory | null, size: number | null } | null> | null, recommendations: Array<{ parentRecommendationId: string | null, shdDeltaAfterUpgrade: string | null, retrofitAction: { displayName: string | null, subjectType: AnnotationCategory | null } | null } | null> | null } | null } | null> | null } | null };

export type PropertyPvQueryVariables = Exact<{
  where: PropertyWhereUnique;
}>;


export type PropertyPvQuery = { property: { pv: { numPanels: number | null, kWp: number | null, annualOutputKwh: number | null } | null } | null };

export type FeConfigQueryVariables = Exact<{ [key: string]: never; }>;


export type FeConfigQuery = { feConfig: { environment: string | null, streetviewApiKey: string | null, locale: string | null, mapboxAccessToken: string | null, gcpProjectId: string | null, osApiKey: string | null } | null };

export class TypedDocumentString<TResult, TVariables>
  extends String
  implements DocumentTypeDecoration<TResult, TVariables>
{
  __apiType?: NonNullable<DocumentTypeDecoration<TResult, TVariables>['__apiType']>;
  private value: string;
  public __meta__?: Record<string, any> | undefined;

  constructor(value: string, __meta__?: Record<string, any> | undefined) {
    super(value);
    this.value = value;
    this.__meta__ = __meta__;
  }

  override toString(): string & DocumentTypeDecoration<TResult, TVariables> {
    return this.value;
  }
}

export const AdminCreateOrganisationDocument = new TypedDocumentString(`
    mutation AdminCreateOrganisation($data: OrganisationCreateInput!) {
  organisationCreate(data: $data) {
    organisation {
      id
      name
    }
  }
}
    `) as unknown as TypedDocumentString<AdminCreateOrganisationMutation, AdminCreateOrganisationMutationVariables>;
export const AdminRenameOrganisationDocument = new TypedDocumentString(`
    mutation AdminRenameOrganisation($id: RoyID, $name: String) {
  organisationUpdate(where: {id: $id}, data: {name: $name}) {
    organisation {
      id
      name
    }
  }
}
    `) as unknown as TypedDocumentString<AdminRenameOrganisationMutation, AdminRenameOrganisationMutationVariables>;
export const AdminCreateUserDocument = new TypedDocumentString(`
    mutation AdminCreateUser($data: CreateUserInput!) {
  createUser(data: $data) {
    user {
      id
    }
  }
}
    `) as unknown as TypedDocumentString<AdminCreateUserMutation, AdminCreateUserMutationVariables>;
export const AdminCreatePropertyListDocument = new TypedDocumentString(`
    mutation AdminCreatePropertyList($name: String!, $organisationId: RoyID) {
  propertyListCreate(data: {name: $name, organisation: {id: $organisationId}}) {
    propertyList {
      id
    }
  }
}
    `) as unknown as TypedDocumentString<AdminCreatePropertyListMutation, AdminCreatePropertyListMutationVariables>;
export const AdminSetPropertyListStatusDocument = new TypedDocumentString(`
    mutation AdminSetPropertyListStatus($id: RoyID, $status: PropertyListStatus) {
  propertyListUpdate(where: {id: $id}, data: {status: $status}) {
    propertyList {
      id
    }
  }
}
    `) as unknown as TypedDocumentString<AdminSetPropertyListStatusMutation, AdminSetPropertyListStatusMutationVariables>;
export const DroneOpsSaveOrderDocument = new TypedDocumentString(`
    mutation DroneOpsSaveOrder($data: [PropertyListBulkUpdateInput!]!) {
  propertyListBulkUpdate(data: $data) {
    propertyLists {
      id
    }
  }
}
    `) as unknown as TypedDocumentString<DroneOpsSaveOrderMutation, DroneOpsSaveOrderMutationVariables>;
export const AdminUpdateUserDocument = new TypedDocumentString(`
    mutation AdminUpdateUser($id: RoyID, $data: UserConfigInput!) {
  userConfig(where: {id: $id}, data: $data) {
    user {
      id
    }
  }
}
    `) as unknown as TypedDocumentString<AdminUpdateUserMutation, AdminUpdateUserMutationVariables>;
export const AdminOrganisationsDocument = new TypedDocumentString(`
    query AdminOrganisations($paging: Paging, $countPaging: Paging) {
  organisations(paging: $paging) {
    id
    name
    users(paging: $countPaging) {
      id
    }
    lists(paging: $countPaging) {
      id
    }
  }
}
    `) as unknown as TypedDocumentString<AdminOrganisationsQuery, AdminOrganisationsQueryVariables>;
export const AdminOrganisationDocument = new TypedDocumentString(`
    query AdminOrganisation($id: RoyID, $countPaging: Paging) {
  organisation(where: {id: $id}) {
    id
    name
    users(paging: $countPaging) {
      id
      username
      email
      role
    }
    lists(paging: $countPaging) {
      id
    }
  }
}
    `) as unknown as TypedDocumentString<AdminOrganisationQuery, AdminOrganisationQueryVariables>;
export const AdminUserRolesDocument = new TypedDocumentString(`
    query AdminUserRoles {
  userRoles {
    userRoles
  }
}
    `) as unknown as TypedDocumentString<AdminUserRolesQuery, AdminUserRolesQueryVariables>;
export const AdminPropertyListsDocument = new TypedDocumentString(`
    query AdminPropertyLists($organisationId: RoyID) {
  propertyLists(where: {organisation: {idIn: [$organisationId]}}) {
    id
    name
    status
    priority
  }
}
    `) as unknown as TypedDocumentString<AdminPropertyListsQuery, AdminPropertyListsQueryVariables>;
export const AdminPropertyListCountDocument = new TypedDocumentString(`
    query AdminPropertyListCount($listId: RoyID) {
  propertyAggregate(where: {lists: {idIn: [$listId]}}) {
    totalCount
  }
}
    `) as unknown as TypedDocumentString<AdminPropertyListCountQuery, AdminPropertyListCountQueryVariables>;
export const DroneOpsPropertyListsDocument = new TypedDocumentString(`
    query DroneOpsPropertyLists {
  propertyLists {
    id
    name
    status
    priority
    organisation {
      id
      name
    }
  }
}
    `) as unknown as TypedDocumentString<DroneOpsPropertyListsQuery, DroneOpsPropertyListsQueryVariables>;
export const ApvFilterOptionsDocument = new TypedDocumentString(`
    query ApvFilterOptions($organisationId: String) {
  apvFilterOptions(organisationId: $organisationId) {
    archetypes
    retrofitActionTypes
  }
}
    `) as unknown as TypedDocumentString<ApvFilterOptionsQuery, ApvFilterOptionsQueryVariables>;
export const OrganisationsDocument = new TypedDocumentString(`
    query Organisations($paging: Paging) {
  organisations(paging: $paging) {
    id
    name
  }
}
    `) as unknown as TypedDocumentString<OrganisationsQuery, OrganisationsQueryVariables>;
export const ApvDataPropertyIdsQueryDocument = new TypedDocumentString(`
    query ApvDataPropertyIdsQuery($organisationId: String, $filterRules: [PrioritisationFilterRule!], $propertyIdIn: [ID!], $page: Int, $pageSize: Int) {
  prioritisationQuery(
    organisationId: $organisationId
    filterRules: $filterRules
    propertyIdIn: $propertyIdIn
    page: $page
    pageSize: $pageSize
  ) {
    rows {
      propertyId
      modelId
    }
    totalCount
  }
}
    `) as unknown as TypedDocumentString<ApvDataPropertyIdsQueryQuery, ApvDataPropertyIdsQueryQueryVariables>;
export const ArvFieldValuesDocument = new TypedDocumentString(`
    query ArvFieldValues($field: ArvValueField!, $organisationId: String, $filterRules: [PrioritisationFilterRule!], $propertyIdIn: [ID!], $limit: Int) {
  arvFieldValues(
    field: $field
    organisationId: $organisationId
    filterRules: $filterRules
    propertyIdIn: $propertyIdIn
    limit: $limit
  ) {
    value
    label
    groupValue
  }
}
    `) as unknown as TypedDocumentString<ArvFieldValuesQuery, ArvFieldValuesQueryVariables>;
export const ApvFieldValuesDocument = new TypedDocumentString(`
    query ApvFieldValues($field: ApvFilterField!, $organisationId: String, $search: String, $limit: Int) {
  apvFieldValues(
    field: $field
    organisationId: $organisationId
    search: $search
    limit: $limit
  ) {
    value
    label
  }
}
    `) as unknown as TypedDocumentString<ApvFieldValuesQuery, ApvFieldValuesQueryVariables>;
export const PlanPropertyListsDocument = new TypedDocumentString(`
    query PlanPropertyLists($where: PropertyListWhere) {
  propertyLists(where: $where) {
    id
    name
  }
}
    `) as unknown as TypedDocumentString<PlanPropertyListsQuery, PlanPropertyListsQueryVariables>;
export const SolarEligibleCountDocument = new TypedDocumentString(`
    query SolarEligibleCount($organisationId: String, $filterRules: [PrioritisationFilterRule!]) {
  prioritisationQuery(
    organisationId: $organisationId
    filterRules: $filterRules
    page: 0
    pageSize: 1
  ) {
    totalCount
  }
}
    `) as unknown as TypedDocumentString<SolarEligibleCountQuery, SolarEligibleCountQueryVariables>;
export const ModelViewerAshpSitesDocument = new TypedDocumentString(`
    query ModelViewerAshpSites($where: ASHPSiteWhere) {
  ashpSites(where: $where) {
    id
    status
    airVolume
    bearing
    noiseImpact
    warnings
    ashpUnit {
      id
      manufacturer
      unitName
      heatingCapacity
      scop
      maxNoise
      width
      height
      depth
    }
  }
}
    `) as unknown as TypedDocumentString<ModelViewerAshpSitesQuery, ModelViewerAshpSitesQueryVariables>;
export const ModelViewerPropertyDocument = new TypedDocumentString(`
    query ModelViewerProperty($organisationId: String, $propertyIdIn: [ID!], $filterRules: [PrioritisationFilterRule!]) {
  prioritisationQuery(
    organisationId: $organisationId
    propertyIdIn: $propertyIdIn
    filterRules: $filterRules
    page: 0
    pageSize: 1
  ) {
    rows {
      propertyId
      modelId
      addressCombined
      propertyType
      buildYear
      epcLodgedGrade
      epcPredictedGrade
      epcLodgedSapScore
      epcPredictedSapScore
      epcLodgedAge
      sapComparatorMode
      comparatorSapPredicted
      comparatorSpaceHeatingIntensity
      comparatorFloorAreaM2
      lodgedFloorAreaM2
      wallUValue
      capturedOn
      recommendations {
        recommendationId
        name
        displayName
        subjectType
        sapUplift
        isAshpRecommendation
        isSolarRecommendation
        solarNumPanels
        solarKwp
        solarAnnualOutputKwh
      }
    }
  }
}
    `) as unknown as TypedDocumentString<ModelViewerPropertyQuery, ModelViewerPropertyQueryVariables>;
export const PlanMapSolarValuesQueryDocument = new TypedDocumentString(`
    query PlanMapSolarValuesQuery($organisationId: String, $filterRules: [PrioritisationFilterRule!], $propertyIdIn: [ID!], $page: Int, $pageSize: Int) {
  prioritisationQuery(
    organisationId: $organisationId
    filterRules: $filterRules
    propertyIdIn: $propertyIdIn
    page: $page
    pageSize: $pageSize
  ) {
    rows {
      propertyId
      modelId
      recommendations {
        isSolarRecommendation
        solarAnnualOutputKwh
        sapUplift
      }
    }
    totalCount
  }
}
    `) as unknown as TypedDocumentString<PlanMapSolarValuesQueryQuery, PlanMapSolarValuesQueryQueryVariables>;
export const PlanMapStreetsDocument = new TypedDocumentString(`
    query PlanMapStreets($where: StreetWhere, $paging: Paging) {
  streets(where: $where, paging: $paging) {
    id
    name
    geometry
  }
}
    `) as unknown as TypedDocumentString<PlanMapStreetsQuery, PlanMapStreetsQueryVariables>;
export const PlanMapQueryDocument = new TypedDocumentString(`
    query PlanMapQuery($organisationId: String, $filterRules: [PrioritisationFilterRule!], $propertyIdIn: [ID!], $page: Int, $pageSize: Int) {
  prioritisationQuery(
    organisationId: $organisationId
    filterRules: $filterRules
    propertyIdIn: $propertyIdIn
    page: $page
    pageSize: $pageSize
  ) {
    rows {
      propertyId
      modelId
      latitude
      longitude
      addressCombined
      epcLodgedGrade
      epcPredictedGrade
      boundary
      streetId
    }
    totalCount
  }
}
    `) as unknown as TypedDocumentString<PlanMapQueryQuery, PlanMapQueryQueryVariables>;
export const PlanPropertyDetailDocument = new TypedDocumentString(`
    query PlanPropertyDetail($organisationId: String, $propertyIdIn: [ID!], $filterRules: [PrioritisationFilterRule!]) {
  prioritisationQuery(
    organisationId: $organisationId
    propertyIdIn: $propertyIdIn
    filterRules: $filterRules
    page: 0
    pageSize: 1
  ) {
    rows {
      propertyId
      modelId
      addressCombined
      city
      propertyType
      archetype
      buildingAge
      epcLodgedGrade
      epcPredictedGrade
      recommendations {
        recommendationId
        name
        displayName
        subjectType
        isSolarRecommendation
        solarNumPanels
        solarKwp
        solarAnnualOutputKwh
        sapUplift
        confidenceLevel
        confidenceScore
        confidenceWarnings
      }
    }
  }
}
    `) as unknown as TypedDocumentString<PlanPropertyDetailQuery, PlanPropertyDetailQueryVariables>;
export const PlanStreetDetailDocument = new TypedDocumentString(`
    query PlanStreetDetail($organisationId: String, $propertyIdIn: [ID!], $pageSize: Int) {
  prioritisationQuery(
    organisationId: $organisationId
    propertyIdIn: $propertyIdIn
    page: 0
    pageSize: $pageSize
  ) {
    rows {
      propertyId
      modelId
      city
      propertyType
      recommendations {
        isSolarRecommendation
        solarNumPanels
        solarKwp
        solarAnnualOutputKwh
      }
    }
  }
}
    `) as unknown as TypedDocumentString<PlanStreetDetailQuery, PlanStreetDetailQueryVariables>;
export const PlanQueryDocument = new TypedDocumentString(`
    query PlanQuery($organisationId: String, $filterRules: [PrioritisationFilterRule!], $sort: [ApvSortInput!], $propertyIdIn: [ID!], $page: Int, $pageSize: Int) {
  prioritisationQuery(
    organisationId: $organisationId
    filterRules: $filterRules
    sort: $sort
    propertyIdIn: $propertyIdIn
    page: $page
    pageSize: $pageSize
  ) {
    rows {
      modelId
      propertyId
      organisationId
      numberOfRetrofitActions
      numberOfUniqueRetrofitActions
      retrofitActionsByType
      numberOfRetrofitActionsByComponent
      wallTotalActions
      roofTotalActions
      windowTotalActions
      doorTotalActions
      chimneyTotalActions
      groundTotalActions
      shdDeltaByAction
      epcLodgedGrade
      epcPredictedGrade
      epcLodgedSapScore
      epcPredictedSapScore
      epcBandDelta
      epcChecker
      epcLodgedAge
      epcPredictedAge
      buildYear
      modelScore
      archetype
      postalcode
      street
      city
      uprn
      addressCombined
      propertyType
      heatPumpId
      heatPumpStatus
      heatPumpLocationSuitability
      heatPumpNoiseCompliance
      heatPumpPublicVisibility
      heatPumpAirVolume
      propertylistIds
      recommendations {
        recommendationId
        propertyId
        modelId
        displayName
        subjectType
        isSolarRecommendation
        solarNumPanels
        solarKwp
        solarAnnualOutputKwh
        sapUplift
        confidenceScore
        confidenceLevel
        confidenceWarnings
      }
    }
    totalCount
  }
}
    `) as unknown as TypedDocumentString<PlanQueryQuery, PlanQueryQueryVariables>;
export const PropertyViewCreateDocument = new TypedDocumentString(`
    mutation PropertyViewCreate($data: PropertyViewCreateInput!, $organisationId: String) {
  propertyViewCreate(data: $data, organisationId: $organisationId) {
    propertyView {
      id
      name
      description
      fieldNamespaceGeneration
      rules
      columns
      sort {
        field
        direction
      }
    }
  }
}
    `) as unknown as TypedDocumentString<PropertyViewCreateMutation, PropertyViewCreateMutationVariables>;
export const PropertyViewUpdateDocument = new TypedDocumentString(`
    mutation PropertyViewUpdate($data: PropertyViewUpdateInput!, $where: PropertyViewWhereUnique!) {
  propertyViewUpdate(data: $data, where: $where) {
    propertyView {
      id
      name
      description
      fieldNamespaceGeneration
      rules
      columns
      sort {
        field
        direction
      }
    }
  }
}
    `) as unknown as TypedDocumentString<PropertyViewUpdateMutation, PropertyViewUpdateMutationVariables>;
export const PropertyViewDeleteDocument = new TypedDocumentString(`
    mutation PropertyViewDelete($where: PropertyViewWhere!) {
  propertyViewDelete(where: $where) {
    success
    rowsAffected
  }
}
    `) as unknown as TypedDocumentString<PropertyViewDeleteMutation, PropertyViewDeleteMutationVariables>;
export const PropertyViewsDocument = new TypedDocumentString(`
    query PropertyViews($where: PropertyViewWhere) {
  propertyViews(where: $where) {
    id
    name
    description
    fieldNamespaceGeneration
    rules
    columns
    sort {
      field
      direction
    }
  }
}
    `) as unknown as TypedDocumentString<PropertyViewsQuery, PropertyViewsQueryVariables>;
export const PropertyListsDocument = new TypedDocumentString(`
    query PropertyLists($where: PropertyListWhere) {
  propertyLists(where: $where) {
    id
    name
  }
}
    `) as unknown as TypedDocumentString<PropertyListsQuery, PropertyListsQueryVariables>;
export const PropertyTablePageDocument = new TypedDocumentString(`
    query PropertyTablePage($where: PropertyWhere!, $paging: Paging!) {
  properties(paging: $paging, where: $where) {
    id
    type
    address(where: {active: true}, paging: {limit: 1}) {
      combined
    }
    units(where: {active: true}, paging: {limit: 1}) {
      form
      age
    }
    kestrixInspections: engPerfInspections(
      where: {sourceIn: [KESTRIX]}
      paging: {limit: 3}
    ) {
      inspectionDate
      source
      spaceHeatingDemand
      currentRating
    }
    epcInspections: engPerfInspections(
      where: {sourceIn: [PROPECO]}
      paging: {limit: 3}
    ) {
      inspectionDate
      source
      spaceHeatingDemand
      currentRating
    }
    predictedInspections: engPerfInspections(
      where: {sourceIn: [KESTRIX_SAP_COMPARATOR]}
      paging: {limit: 3}
    ) {
      inspectionDate
      source
      currentRating
    }
    models(where: {model: {active: true}}, paging: {limit: 1}) {
      modelId
      model {
        id
        active
      }
    }
  }
}
    `) as unknown as TypedDocumentString<PropertyTablePageQuery, PropertyTablePageQueryVariables>;
export const PropertyMapMarkersPageDocument = new TypedDocumentString(`
    query PropertyMapMarkersPage($where: PropertyWhere!, $paging: Paging!) {
  properties(paging: $paging, where: $where) {
    id
    address(where: {active: true}, paging: {limit: 1}) {
      combined
      latlng
    }
    epcInspections: engPerfInspections(
      where: {sourceIn: [PROPECO]}
      paging: {limit: 3}
    ) {
      currentRating
      inspectionDate
    }
    predictedInspections: engPerfInspections(
      where: {sourceIn: [KESTRIX_SAP_COMPARATOR]}
      paging: {limit: 3}
    ) {
      currentRating
      inspectionDate
    }
    models(where: {model: {active: true}}, paging: {limit: 1}) {
      modelId
    }
  }
}
    `) as unknown as TypedDocumentString<PropertyMapMarkersPageQuery, PropertyMapMarkersPageQueryVariables>;
export const PropertyOverlayDocument = new TypedDocumentString(`
    query PropertyOverlay($where: PropertyWhereUnique!) {
  property(where: $where) {
    id
    type
    address(where: {active: true}, paging: {limit: 1}) {
      combined
      latlng
      uprn
    }
    units(where: {active: true}, paging: {limit: 1}) {
      form
      age
    }
    kestrixInspections: engPerfInspections(
      where: {sourceIn: [KESTRIX]}
      paging: {limit: 1}
    ) {
      inspectionDate
      source
      spaceHeatingDemand
      currentRating
    }
    epcInspections: engPerfInspections(
      where: {sourceIn: [PROPECO]}
      paging: {limit: 1}
    ) {
      inspectionDate
      source
      spaceHeatingDemand
      currentRating
    }
    predictedInspections: engPerfInspections(
      where: {sourceIn: [KESTRIX_SAP_COMPARATOR]}
      paging: {limit: 1}
    ) {
      inspectionDate
      source
      currentRating
    }
    models(where: {model: {active: true}}, paging: {limit: 1}) {
      modelId
      model {
        id
        active
        recommendations {
          parentRecommendationId
          shdDeltaAfterUpgrade
          retrofitAction {
            displayName
            subjectType
          }
        }
      }
    }
  }
}
    `) as unknown as TypedDocumentString<PropertyOverlayQuery, PropertyOverlayQueryVariables>;
export const PropertyDetailDocument = new TypedDocumentString(`
    query PropertyDetail($where: PropertyWhereUnique!) {
  property(where: $where) {
    id
    type
    address(where: {active: true}, paging: {limit: 1}) {
      uprn
      combined
      latlng
    }
    units(where: {active: true}, paging: {limit: 1}) {
      form
      age
    }
    kestrixInspections: engPerfInspections(
      where: {sourceIn: [KESTRIX]}
      paging: {limit: 3}
    ) {
      inspectionDate
      source
      spaceHeatingDemand
      currentRating
    }
    epcInspections: engPerfInspections(
      where: {sourceIn: [PROPECO]}
      paging: {limit: 3}
    ) {
      inspectionDate
      source
      spaceHeatingDemand
      currentRating
    }
    models(where: {model: {active: true}}) {
      model {
        id
        active
        files {
          glb
        }
        annotations {
          active
          type
          category
          size
        }
        recommendations {
          parentRecommendationId
          shdDeltaAfterUpgrade
          retrofitAction {
            displayName
            subjectType
          }
        }
      }
    }
  }
}
    `) as unknown as TypedDocumentString<PropertyDetailQuery, PropertyDetailQueryVariables>;
export const PropertyPvDocument = new TypedDocumentString(`
    query PropertyPv($where: PropertyWhereUnique!) {
  property(where: $where) {
    pv {
      numPanels
      kWp
      annualOutputKwh
    }
  }
}
    `) as unknown as TypedDocumentString<PropertyPvQuery, PropertyPvQueryVariables>;
export const FeConfigDocument = new TypedDocumentString(`
    query FeConfig {
  feConfig {
    environment
    streetviewApiKey
    locale
    mapboxAccessToken
    gcpProjectId
    osApiKey
  }
}
    `) as unknown as TypedDocumentString<FeConfigQuery, FeConfigQueryVariables>;